import React from 'react'
import { colors } from '../../constants/colors'
import { styled } from '@mui/material';

const CheckmarkIcon = ({ color, size = 14 }: { color?: string; size?: number }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <StyledPath
            d="M5 13.2L9.28571 18L20 6"
            strokeColor={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

const StyledPath = styled('path') <{ strokeColor?: string }>`
  ${({ theme, strokeColor }) => `
    stroke: ${strokeColor != null ? strokeColor : theme.palette.mode == 'dark'
            ? colors.DARK_MODE_30
            : colors.GEORGIAN_BAY_100
        };
  `}
`

export default CheckmarkIcon

